import React from 'react';
import classNames from 'classnames';
import { Image } from '@wix/image';
import { getImageUri, type MediaPlatformImage } from '@wix/communities-blog-client-common';
import { AvatarPlaceholder } from '../icons/avatar-placeholder';
import styles from './fluid-avatar-image.scss';

interface Props {
  image?: MediaPlatformImage;
  size: number;
  ariaLabel: string;
  className?: string;
}

const FluidAvatarImage: React.FC<Props> = ({ image, size, ariaLabel, className }) => {
  const uri = getImageUri(image) ?? (image && 'url' in image ? image.url : undefined);

  if (!uri) {
    return (
      <span
        aria-label={ariaLabel}
        className={classNames(styles.container, 'fluid-avatar-image', className)}
        data-hook="avatar-image"
        role="img"
      >
        <AvatarPlaceholder className={styles.placeholder} />
      </span>
    );
  }

  return (
    <Image
      alt={ariaLabel}
      className={classNames(styles.container, 'fluid-avatar-image', className)}
      uri={uri}
      displayMode="fill"
      width={size}
      height={size}
      targetWidth={size}
      targetHeight={size}
      data-hook="avatar-image"
      role="img"
      encoding="AVIF"
    />
  );
};

export default FluidAvatarImage;
